import {
    createDefaultPanelSessionState,
    loadPanelSessionState,
    updatePanelSessionState,
} from '../../shared/panels/panelSessionState.ts';
import type { PanelStateStorage } from '../../shared/panels/panelSessionState.ts';

const PANEL_ID = 'asset-information';
const createDefaults = () => createDefaultPanelSessionState({
    panelId: PANEL_ID,
    isOpen: false,
    pinnedWidth: 330,
});

export const loadAssetInformationPanelOpen = (storage?: PanelStateStorage | null): boolean => {
    return loadPanelSessionState(PANEL_ID, createDefaults(), storage).isOpen;
};

// Persist the user's preference, never the selection-dependent rendered visibility.
export const saveAssetInformationPanelOpen = (isOpen: boolean, storage?: PanelStateStorage | null): void => {
    updatePanelSessionState(PANEL_ID, createDefaults(), { isOpen }, storage);
};
